var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmoji(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2682_1351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 18C14.4706 18 18.5 13.9706 18.5 9C18.5 4.02944 14.4706 0 9.5 0C4.52944 0 0.5 4.02944 0.5 9C0.5 13.9706 4.52944 18 9.5 18Z",
    fill: "#FFD54F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.49991 13.5C7.86198 13.5 6.32284 12.8626 5.16479 11.7039C4.94507 11.4841 4.94507 11.128 5.16479 10.9083C5.38452 10.6886 5.74065 10.6886 5.96038 10.9083C6.90538 11.8547 8.16222 12.3754 9.49956 12.3754C10.8369 12.3754 12.0937 11.8547 13.0394 10.909C13.2592 10.6893 13.6153 10.6893 13.835 10.909C14.0548 11.1287 14.0548 11.4848 13.835 11.7046C12.6763 12.8626 11.1371 13.5 9.49921 13.5H9.49991Z",
    fill: "#6D4C41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.44118 8.27273H5.08824C4.7636 8.27273 4.5 8.01811 4.5 7.70455C4.5 7.39098 4.7636 7.13637 5.08824 7.13637H7.44118C7.76581 7.13637 8.02941 7.39098 8.02941 7.70455C8.02941 8.01811 7.76581 8.27273 7.44118 8.27273Z",
    fill: "#6D4C41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.323 8.27274C13.9727 8.27274 14.4994 7.76398 14.4994 7.13638C14.4994 6.50878 13.9727 6.00002 13.323 6.00002C12.6732 6.00002 12.1465 6.50878 12.1465 7.13638C12.1465 7.76398 12.6732 8.27274 13.323 8.27274Z",
    fill: "#6D4C41"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2682_1351"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji);
export default __webpack_public_path__ + "static/media/emoji.b9d81670e222e9a2f00ee71fd8a7fdc3.svg";
export { ForwardRef as ReactComponent };